import $ from 'jquery';
import FontFaceObserver from 'fontfaceobserver';
import getSvgFonts from 'svg-config/src/js/utils/getSvgFonts';
import SVGView from 'svg-config/src/js/components/SVGView';

let viewSequence = 0;

export default function svgConfigViewExport({ svgUrl, svgPersonalized }) {
  viewSequence += 1;
  const svgViewId = `svg-view-export-${viewSequence}`;
  const $svgView = $(`<div id="${svgViewId}" class="visuallyhidden"></div>`);

  $('body').append($svgView);

  const svgView = new SVGView({
    svgView: `#${svgViewId}`,
    photoUrl: window.si_data.broker.photoThumbnail || window.si_env.placeholderPortrait,
    logoUrl: window.si_data.agency.logo || '',
    content: {
      ...(window.si_data.agency ? {
        aname: window.si_data.agency.corporateName,
        aphone: window.si_data.agency.telephone,
        aurl: window.si_data.agency.website,
      } : {}),
      ...(window.si_data.brand ? {
        replacementPatterns: window.si_data.brand.replacementPatterns,
      } : {}),
      ...(svgPersonalized ? {} : {
        bmail: window.si_data.broker.email,
        bphone: window.si_data.broker.telephone,
        burl: window.si_data.broker.website,
        fname: window.si_data.broker.firstName,
        lname: window.si_data.broker.lastName,
        name: window.si_data.broker.name,
        title: window.si_data.broker.title,
      }),
      date: window.si_data.microtext,
    },
  });
      
  return fetch(svgUrl, { mode: 'cors' })
    .then(response => response.text())
    .then(svgString => (
      Promise.all(getSvgFonts(svgString).map(font => (
        new FontFaceObserver(font).load()
          .then(() => undefined, () => { throw font; })
      )))
        .then(() => svgView.load(svgUrl), (font) => {
          // a font could not be loaded
          // todo: notify the product owner?
          throw font;
        })
        .then(() => svgView.exportForPrint({
          photoUrl: window.si_data.broker.photo,
        }))
        .then((exportedSvgString) => {
          window.requestIdleCallback(() => {
            $svgView.remove();
          });

          return exportedSvgString;
        })
    ));
}
